import React, { Component } from 'react';
import { isFunction } from 'lodash/lang';
import { AnalyticsConsumer } from '../providers/AnalyticsProvider';

const withInputAnalytics = (analyticsConsumerProps) => (WrappedComponent) =>
  class AnalyticsInputComponent extends Component {
    static defaultProps = {
      trackValue: false,
    };

    startEventSent = false;

    handleChange = (sendAction) => (event, ...rest) => {
      const { value, startEventAction, editEventAction, onChange } = this.props;

      if (isFunction(onChange)) {
        onChange(event, ...rest);
      }

      if (this.startEventSent) {
        return;
      }

      this.startEventSent = true;
      const action = value ? editEventAction : startEventAction;

      if (action) {
        sendAction(action);
      }
    };

    handleBlur = (sendAction) => (event, ...rest) => {
      const { finishEventAction, trackValue, onBlur } = this.props;
      const label = trackValue ? event.target.value : null;

      if (isFunction(onBlur)) {
        onBlur(event, ...rest);
      }

      if (!this.startEventSent) {
        return;
      }

      this.startEventSent = false;

      if (finishEventAction) {
        sendAction(finishEventAction, label);
      }
    };

    render() {
      const {
        analyticsActionName,
        analyticsLabel,
        analyticsCustomOptions,
        startEventAction,
        editEventAction,
        finishEventAction,
        trackValue,
        onClick,
        ...rest
      } = this.props;

      return (
        <AnalyticsConsumer {...analyticsConsumerProps}>
          {({ sendAction, dataProps }) => (
            <WrappedComponent
              {...dataProps}
              {...rest}
              onChange={this.handleChange(sendAction)}
              onBlur={this.handleBlur(sendAction)}
            />
          )}
        </AnalyticsConsumer>
      );
    }
  };

export default withInputAnalytics;
